export default __webpack_public_path__ + "6999bd0aca77f3ecf80e5548eafd1ba4.png";